import { render, staticRenderFns } from "./ProductBox.vue?vue&type=template&id=c0f45460&"
import script from "./ProductBox.vue?vue&type=script&lang=js&"
export * from "./ProductBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports